// src/index.ts
import { defineApp } from "@ex0/kernel";
var CLOCK_PADDING = "2rem";
var CLOCK_CSS = `
  .clock-outer {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 26rem;
    width: 26rem;
    border-radius: 50%;
  }
  .clock-inner {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 26rem;
    width: 26rem;
    border-radius: 50%;
    border: 4px solid black;
    background-color: white;
  }
  .clock-center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    height: 1.5rem;
    width: 1.5rem;
    background: #0b0b0b;
    border-radius: 50%;
  }
  .clock-center-second {
    background: red;
    height: 0.8rem;
    width: 0.8rem;
  }
  .clock-second-hand {
    height: 10rem;
    width: 0.1rem;
    background: red;
    transform: translateY(-4rem);
  }
  .clock-minute-hand {
    height: 0;
    width: 1rem;
    border-bottom: 9rem solid black;
    border-right: 0.4rem solid transparent;
    border-left: 0.4rem solid transparent;
    transform: translateY(-4.5rem);
  }
  .clock-hour-hand {
    height: 0;
    width: 1rem;
    border-bottom: 10rem solid black;
    border-right: 0.4rem solid transparent;
    border-left: 0.4rem solid transparent;
    transform: translateY(-3rem);
  }
  .clock-segments {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -100%);
  }
  .clock-segment {
    position: absolute;
    top: 0;
    left: 0;
    height: 12.8rem;
    width: 0px;
    transform-origin: center top;
  }
  .clock-mark {
    height: 1.2rem;
    width: 1px;
    background: black;
  }
  .clock-mark-hour {
    height: 1.2rem;
    transform: translateX(-2px);
    width: 4px;
  }
  .clock-num {
    position: absolute;
    top: 2.7rem;
    left: 50%;
    text-align: center;
    line-height: 0;
    font-size: 2rem;
    font-weight: 700;
    font-family: helvetica;
  }
`;
var src_default = defineApp({
  id: "clock",
  name: "Clock",
  description: "Analog clock",
  singleton: true,
  window: {
    title: "Clock",
    size: { width: 210, height: 210 },
    constraints: { minWidth: 150, minHeight: 150 }
  },
  mount(container) {
    const wrapper = document.createElement("div");
    wrapper.style.cssText = `background-color:#c0c0c0;width:100%;height:100%;position:relative;padding:${CLOCK_PADDING};box-sizing:border-box;`;
    const style = document.createElement("style");
    style.textContent = CLOCK_CSS;
    wrapper.appendChild(style);
    const outer = document.createElement("div");
    outer.className = "clock-outer";
    const inner = document.createElement("div");
    inner.className = "clock-inner";
    const hourCenter = document.createElement("div");
    hourCenter.className = "clock-center";
    const hourHand = document.createElement("div");
    hourHand.className = "clock-hour-hand";
    hourCenter.appendChild(hourHand);
    const minCenter = document.createElement("div");
    minCenter.className = "clock-center";
    const minHand = document.createElement("div");
    minHand.className = "clock-minute-hand";
    minCenter.appendChild(minHand);
    const secCenter = document.createElement("div");
    secCenter.className = "clock-center clock-center-second";
    const secHand = document.createElement("div");
    secHand.className = "clock-second-hand";
    secCenter.appendChild(secHand);
    const segments = document.createElement("div");
    segments.className = "clock-segments";
    let segRotation = 0;
    let numRotation = 0;
    for (let idx = 1; idx <= 60; idx++) {
      const segment = document.createElement("div");
      segment.className = "clock-segment";
      segRotation += 6;
      segment.style.transform = `rotate(${segRotation}deg) translate(-50%, -100%)`;
      const mark = document.createElement("div");
      mark.className = "clock-mark";
      if (idx % 5 === 0) {
        const num = document.createElement("span");
        num.className = "clock-num";
        num.textContent = String(idx / 5);
        numRotation += 30;
        num.style.transform = `translateX(-50%) rotate(-${numRotation}deg)`;
        mark.classList.add("clock-mark-hour");
        segment.appendChild(mark);
        segment.appendChild(num);
      } else {
        segment.appendChild(mark);
      }
      segments.appendChild(segment);
    }
    inner.appendChild(hourCenter);
    inner.appendChild(minCenter);
    inner.appendChild(secCenter);
    inner.appendChild(segments);
    outer.appendChild(inner);
    wrapper.appendChild(outer);
    container.appendChild(wrapper);
    const ro = new ResizeObserver((entries) => {
      const rem = parseFloat(
        getComputedStyle(document.documentElement).fontSize
      );
      const clockVisualSize = 26 * rem + 8;
      for (const entry of entries) {
        const { width, height } = entry.contentRect;
        const scale = Math.min(width, height) / clockVisualSize;
        inner.style.transform = `scale(${scale})`;
      }
    });
    ro.observe(wrapper);
    let timer;
    function updateHands() {
      const time = /* @__PURE__ */ new Date();
      const hours = time.getHours();
      const minutes = time.getMinutes();
      const seconds = time.getSeconds();
      const hourPos = hours * 360 / 12 + minutes * 360 / 60 / 12;
      const minPos = minutes * 360 / 60 + seconds * 6 / 60;
      const secPos = seconds * 360 / 60;
      hourHand.style.transform = `rotate(${hourPos}deg) translateY(-3rem)`;
      minHand.style.transform = `rotate(${minPos}deg) translateY(-4.5rem)`;
      secHand.style.transform = `rotate(${secPos}deg) translateY(-4rem)`;
    }
    updateHands();
    timer = setInterval(updateHands, 1e3);
    return {
      dispose() {
        clearInterval(timer);
        ro.disconnect();
      }
    };
  }
});
export {
  src_default as default
};
